<div class="container-fluid">
  <div class="row" id="supervisorSkillAreasButtons">
    <div class="d-flex flex-row gap-3 ms-3 me-3">
      <button
        (click)="addSkillAreaButtonClicked()"
        class="side-menu-button2 w-100"
        id="addSkillAreaButton"
      >
        + Skill Area
      </button>
      <button
        (click)="getFromBSPButtonClicked()"
        class="side-menu-button2 w-100"
        [id]="academyModeService.getImportButtonId()"
      >
        {{ academyModeService.getImportButtonLabel() }}
      </button>
    </div>
  </div>

  <p-table
    [value]="filteredSkillAreas()"
    #dt
    id="skillAreasList"
    dataKey="ID"
    [tableStyle]="{ width: '100%' }"
    [loading]="loadingSkillAreas"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="true"
    [responsive]="true"
    [resizableColumns]="true"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    [scrollHeight]="'flex'"
  >
    <ng-template pTemplate="caption">
      <div class="container text-center">
        <div class="row">
          <div class="col">
            <span class="p-input-icon-left w-100">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                class="w-100"
                placeholder="Skill Area Name"
                id="searchBarInput"
                [(ngModel)]="searchKeyword"
              />
            </span>
          </div>
        </div>

        <div class="row mt-3" id="skillAreasFiltersButtons">
          <div class="d-flex flex-wrap gap-3 justify-content-end">
            @if(!includeDeleted()) {
            <p-button
              id="includeDeletedButton"
              [style]="{
                color: 'red',
                backgroundColor: 'white',
                border: '2px solid red',
                'border-radius': '10px'
              }"
              label="Include Deleted"
              icon="pi pi-trash"
              (onClick)="toggleIncludeDeleted()"
            />
            } @else {
            <p-button
              [style]="{
                color: 'white',
                backgroundColor: 'red',
                border: '2px solid white',
                'border-radius': '10px'
              }"
              label="Exclude Deleted"
              icon="pi pi-trash"
              (onClick)="toggleIncludeDeleted()"
            />
            }

            <p-button
              label="Clear"
              [style]="{
                'border-radius': '10px',
                border: '2px solid #719eb6'
              }"
              icon="pi pi-filter-slash"
              (click)="clearSearch()"
            />
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-skillArea>
      <app-skill-area [skillArea]="skillArea" [id]="skillArea?.SkillAreaName" />
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <p
        style="
          text-align: center;
          margin-top: 20px;
          font-size: 1rem;
          color: #719eb6;
        "
      >
        There are no Skill Areas yet.
      </p>
    </ng-template>
  </p-table>
</div>
